import {
    createCoupon,
    deleteCoupon,
    updateCoupon,
    getCouponsList,
    getPlanGroups,
    getPlanTypeByGroup
} from '@/api/discountCoupons'
import {
    getDiscounts
} from '@/api/discount'

const state = {
    couponsList: [],
    planGroups: {},
    planTypesByGroup: {},
    discounts: {}
}

const getters = {
    getCouponsList: state => state.couponsList,
    getPlanGroups: state => state.planGroups,
    getPlanTypesByGroup: state => state.planTypesByGroup,
    getDiscounts: state => state.discounts,
}

const mutations = {
    SET_COUPONS_LIST: (state, payload) => state.couponsList = payload,
    SET_DISCOUNTS: (state, payload) => state.discounts = payload,
    SET_PLAN_GROUPS: (state, payload) => state.planGroups = payload,
    SET_PLAN_TYPES_BY_GROUP: (state, payload) => state.planTypesByGroup = payload,
    CREATE_COUPON: (state, payload) => state.couponsList.push(payload),
    REMOVE_COUPON: (state, id) => {
        const index = state.couponsList.findIndex(coupon => coupon.id === id)
        state.couponsList.splice(index, 1)
    },
    UPDATE_COUPON: (state, payload) => state.couponsList.filter(coupon => coupon.id === payload.id)[0] = payload
}

const actions = {
    getCouponsList: ({ commit }) => {
        getCouponsList()
            .then(response => {
                const couponsList = []
                response.data.forEach(coupon => {
                    couponsList.push(coupon)
                })
                commit('SET_COUPONS_LIST', couponsList)
            })
            .catch(error => error.response)
    },

    getPlanGroups: ({ commit }) => {
        getPlanGroups()
            .then(response => commit('SET_PLAN_GROUPS', response))
            .catch(error => error.response)
    },

    getPlanTypesByGroup: ({ commit }, groupId) => {
        getPlanTypeByGroup(groupId)
            .then(response => commit('SET_PLAN_TYPES_BY_GROUP', response))
            .catch(error => error.response)
    },

    getDiscounts: ({ commit }) => {
        getDiscounts()
            .then(response => {
                commit('SET_DISCOUNTS', response.data)
            })
            .catch(error => error.response)
    },

    createCoupon: ({ commit }, data) => new Promise((resolve, reject) => {
        const coupon = data

        createCoupon(coupon)
            .then(response => {
                commit('CREATE_COUPON', response.data)

                return resolve(response)
            })
            .catch(error => reject(error.response.data))
    }),

    deleteCoupon: ({ commit }, couponId) => {
        deleteCoupon(couponId)
            .then(() => commit('REMOVE_COUPON', couponId))
            .catch(error => error.response)
    },

    updateCoupon: ({ commit }, data) => new Promise((resolve, reject) => {
        updateCoupon(data)
            .then(response => {
                commit('UPDATE_COUPON', response.data)
                return resolve(response.data)
            })
            .catch(error => reject(error.response))
    })
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
